import { InjectionToken } from '@angular/core';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';
import { ICoreService } from '../interfaces/core-service.interface';
import { IVestraUserService } from '../interfaces/provider-service.interface';

export const AuthenticationService_TOKEN = new InjectionToken<IAuthenticationService>('account-service');

export const CoreService_TOKEN = new InjectionToken<ICoreService>('core-service');
export const VestraUserService_TOKEN = new InjectionToken<IVestraUserService>('vestra-user-service');
